import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Layout from "./components/Layout";
import Home from "./components/Home";
import About from "./components/About";
import Prices from "./components/Prices";
import Socials from "./components/Socials";
import Contact from "./components/Contact";
import TermsOfService from "./components/TermsOfService";
import PrivacyPolicy from "./components/PrivacyPolicy";
function App() {
  // Set the browser tab title globally
  useEffect(() => {
    document.title = "The Party Parlour";
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="About" element={<About />} />
          <Route path="Prices" element={<Prices />} />
          <Route path="Socials" element={<Socials />} />
          <Route path="Contact" element={<Contact />} />
          <Route path="TermsOfService" element={<TermsOfService />} />
          <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
